import React, { useEffect, useState } from "react";
import {
  CheckBoxInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/common/ui/Button";
import { facilityAction } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import Table from "../../components/common/table/Table";
import { useLocation } from "react-router-dom";
import AddIcon from '../../assets/svg/btn_icons/create-btn-icon.svg'

function FacilityForms({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const InmateForm = useSelector((x) => x?.facility?.InmateForm);
  const ManagementForm = useSelector((x) => x?.facility?.ManagementForm);
  const FormsDetails = useSelector((x) => x?.facility?.FormsDetails);
  const { facilityFrequencyCount, facilityFrequencyType, Status } = useSelector(
    (state) => state.dropdownOptions
  );

  const staticRequestFormTypeID = [1, 2, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63];
  //const [isManagementSelectAll, setIsManagementSelectAll] = useState(false);
  //const [isInmateSelectAll, setIsInmateSelectAll] = useState(false);
  //const [inmateRequestForm, setInmateRequestForm] = useState([]);
  //const [checkInmateRequestForm, setCheckInmateRequestForm] = useState([]);

  const facilityID = location?.state ? location?.state?.facilityID : 0;
  const getInmateFormDetails = facilityInformationData?.getInmateFormDetails;
  // const [showSelectedFormTable, setShowSelectedFormTable] = useState(false);
  //const [managementRequestForm, setManagementRequestForm] = useState([]);
  //const [checkManagementRequestForm, setCheckManagementRequestForm] = useState([]);
  // const [inmateFormTable, setInmateFormTable] = useState([]);
  // const [managementFormTable, setManagementFormTable] = useState([]);

  useEffect(() => {
    if ((facilityID === 0 || facilityID > 0) && !facilityInformationData?.PrePopulate) {
      let updatedFormsDetails = { ...FormsDetails };
      updatedFormsDetails.inmateRequestForm = InmateForm;
      if (facilityID > 0) {
        updatedFormsDetails.checkInmateRequestForm = InmateForm;
      }
      else {
        updatedFormsDetails.checkInmateRequestForm = [];
        updatedFormsDetails.isInmateSelectAll = false;
      }
      //setInmateRequestForm(InmateForm);
      //setCheckInmateRequestForm(InmateForm);
      dispatch(facilityAction.setFormsDetails(updatedFormsDetails));

    }
  }, [InmateForm]);

  useEffect(() => {
    if ((facilityID === 0 || facilityID > 0) && !facilityInformationData?.PrePopulate) {
      let updatedFormsDetails = { ...FormsDetails };
      updatedFormsDetails.managementRequestForm = ManagementForm;
      if (facilityID > 0) {
        updatedFormsDetails.checkManagementRequestForm = ManagementForm;
      }
      else {
        updatedFormsDetails.checkManagementRequestForm = [];
        updatedFormsDetails.isManagementSelectAll = false;
      }
      dispatch(facilityAction.setFormsDetails(updatedFormsDetails));
      //setManagementRequestForm(ManagementForm);
      //setCheckManagementRequestForm(ManagementForm);
    }
  }, [ManagementForm]);

  useEffect(() => {
    getInmateRequestForm();
    getManagementRequestForm();
  }, []);

  useEffect(() => {
    if (
      getInmateFormDetails &&
      (facilityID > 0 || facilityInformationData?.PrePopulate) &&
      facilityInformationData?.Type_RequestFormPermission
    ) {
      const facilityData = { ...facilityInformationData };
      let updatedFormsDetails = { ...FormsDetails };
      const updatedForm =
        facilityInformationData?.Type_RequestFormPermission?.map((form) => {
          if (
            // form?.RequestFormType === "Visitor Request Form" ||
            // form?.RequestFormType === "Public Defender Services" ||
            // form?.RequestFormType === "Public Defender Services - Crisp"
            form?.RequestFormTypeID === 1 ||
            form?.RequestFormTypeID === 59 ||
            form?.RequestFormTypeID === 62 || form?.RequestFormTypeID === 63
          ) {
            return { ...form, isActive: true, isShowSelectBox: false };
          }
          return { ...form, isActive: true, isShowSelectBox: true };
        });
      facilityData["Type_RequestFormPermission"] = updatedForm;

      //update inmate check box
      const updateInmateCheckbox = InmateForm.map((item1) => {
        const matchingItem = facilityData["Type_RequestFormPermission"].find(
          (item2) => item2.RequestFormTypeID === item1.RequestFormTypeID
        );

        if (matchingItem) {
          return { ...item1, isActive: true };
        } else {
          return { ...item1 };
        }
      });
      //setInmateRequestForm(updateInmateCheckbox);
      //setCheckInmateRequestForm(updateInmateCheckbox);
      updatedFormsDetails.inmateRequestForm = updateInmateCheckbox;
      updatedFormsDetails.checkInmateRequestForm = updateInmateCheckbox;

      const IsAllInmateRequestForm = updateInmateCheckbox.every((data) => data.isActive === true);
      updatedFormsDetails.isInmateSelectAll = (IsAllInmateRequestForm && updateInmateCheckbox.length === InmateForm.length);
      //update MG User check box
      const updateMGUserCheckbox = ManagementForm.map((item1) => {
        const matchingItem = facilityData[
          "Type_RequestMGUserFormPermission"
        ].find((item2) => item2.RequestFormTypeID === item1.RequestFormTypeID);

        if (matchingItem) {
          return { ...item1, isActive: true };
        } else {
          return { ...item1 };
        }
      });
      //setManagementRequestForm(updateMGUserCheckbox);
      //setCheckManagementRequestForm(updateMGUserCheckbox);
      updatedFormsDetails.managementRequestForm = updateMGUserCheckbox;
      updatedFormsDetails.checkManagementRequestForm = updateMGUserCheckbox;

      const IsAllmanagementRequestForm = updateMGUserCheckbox.every((data) => data.isActive === true);
      updatedFormsDetails.isManagementSelectAll = (IsAllmanagementRequestForm && updateMGUserCheckbox.length === ManagementForm.length);

      dispatch(facilityAction.setFormsDetails(updatedFormsDetails));
      dispatch(facilityAction.setFacilityData(facilityData));
    }
  }, [getInmateFormDetails]);


  const inmateTableColumn = [

    {
      width: window.innerWidth <= 850 ? '220px' : undefined,
      name: "Form Title",
      selector: (row) => row.RequestFormTypeID,
      sortable: false,
      cell: (row, i) => {
        return (
          <div className="w-100">
            <div className="d-flex flex-wrap align-items-center">
              <TextInput
                placeholder="Form Title"
                name={`Type_RequestFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`}
                id={"InmateFacilityRequestFormTitle" + i}
                label={row?.RequestFormType}
                handleChange={(e) => handleInmateFormTableChanges(e, row)}
                handleBlur={(e) => handleInmateFormTableOnblur(e, row)}
                value={
                  facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                  "FacilityRequestFormTitle"
                  ]
                }
                required
                errorMessage={errorMessage}
                maxLength={99}
              />
              {/* <span style={{ color: 'red', marginLeft: '5px' }}>*</span> */} {/* Mandatory symbol */}
            </div>
          </div>
        );
      },

      top: true,
    },

    {
      width: window.innerWidth <= 850 ? '150px' : undefined,
      name: "Frequency Count",
      selector: (row) => row.RequestFormTypeID,
      sortable: false,
      cell: (row, i) =>
        row.isShowSelectBox ? (
          <div className="w-100 mt-3">
            <SelectInput
              name={`Type_RequestFormPermission.${row.RequestFormTypeID}.FrequencyCount`}
              id={"FrequencyCount" + i}
              options={
                staticRequestFormTypeID.includes(row.RequestFormTypeID)
                  ? facilityFrequencyCount
                  : [
                    { label: "NA", value: -1 },
                    { label: "0", value: 0 },
                    ...facilityFrequencyCount.slice(1),
                  ]
              }
              handleChange={(e) =>
                handleInmateFormTableChanges(e, row, "FrequencyCount")
              }
              value={
                facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "FrequencyCount"
                ]
              }
              isClearable={facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "FrequencyCount"
              ] == -1 ? false : true}
            />
          </div>
        ) : (
          "NA"
        ),
      top: true,
    },

    {
      width: window.innerWidth <= 850 ? '170px' : undefined,
      name: "Frequency Type",
      selector: (row) => row.RequestFormTypeID,
      sortable: false,
      cell: (row, i) =>
        row.isShowSelectBox ? (
          <div className="w-100 mt-3">
            <SelectInput
              options={facilityFrequencyType}
              name={`Type_RequestFormPermission.${row.RequestFormTypeID}.FrequencyCalenderType`}
              isDisabled={facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "FrequencyCount"
              ] === -1}
              id={"FrequencyCalenderType" + i}
              handleChange={(e) =>
                handleInmateFormTableChanges(e, row, "FrequencyCalenderType")
              }
              value={
                facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "FrequencyCalenderType"
                ]
              }
              isClearable={facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "FrequencyCalenderType"
              ] == -1 ? false : true}
            />
          </div>
        ) : (
          "NA"
        ),
      top: true,
    },

    {
      width: window.innerWidth <= 850 ? '150px' : undefined,
      name: "Status",
      selector: (row, i) => row.RequestFormTypeID,
      sortable: false,
      cell: (row, i) => (
        <div className="row col-lg-12 m-2 resp-space">
          <div className="form-check col-lg-6 width:'150px',">
            <input
              type="radio"
              className="form-check-input"
              name={`Type_RequestFormPermission.${i}.ActiveStatus-`}
              value={1}
              id={`active-status-${i}`}
              checked={
                facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "ActiveStatus"
                ] === 1
              }
              onChange={(e) => handleInmateFormTableChanges(e, row)}
            />
            <label className="form-check-label fs-5" htmlFor={`active-status-${i}`}>Active</label>
          </div>

          <div className="form-check col-lg-6">
            <input
              type="radio"
              className="form-check-input"
              name={`Type_RequestFormPermission.${i}.ActiveStatus-`}
              value={0}
              id={`inactive-status-${i}`}
              checked={
                facilityInformationData["Type_RequestFormPermission"]?.[i]?.[
                "ActiveStatus"
                ] === 0
              }
              onChange={(e) => handleInmateFormTableChanges(e, row)}
            />
            <label className="form-check-label fs-5" htmlFor={`inactive-status-${i}`}>Inactive</label>
          </div>
        </div>
      ),
    },
  ];

  const managementTableColumn = [

    {
      width: window.innerWidth <= 850 ? '150px' : undefined,
      name: "Form",
      selector: (row) => row.RequestFormType,
      sortable: false,
    },

    {
      width: window.innerWidth <= 850 ? '150px' : undefined,
      name: "Form Title",
      selector: (row) => row.FacilityCode,
      cell: (row, i) => (
        <div className="w-100"> <div className="d-flex flex-wrap align-items-center">
          <TextInput
            label={"Form Title"}
            name={`Type_RequestMGUserFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`}
            id={"Type_RequestMGUserFormPermissiontFormTitle" + i}
            placeholder={"Form Title"}
            handleChange={(e) => handleManagementFormTableChanges(e, row)}
            handleBlur={(e) => handleManagementFormTableOnblur(e, row)}
            value={
              facilityInformationData["Type_RequestMGUserFormPermission"][i]?.[
              "FacilityRequestFormTitle"
              ]
            }
            required
            errorMessage={errorMessage}
            maxLength={99}
          />
          {/* <span style={{ color: 'red', marginLeft: '5px' }}>*</span> */}
          {/* Mandatory symbol */}
        </div>
        </div>
      ),
      sortable: false,
    },


    {
      width: window.innerWidth <= 850 ? '150px' : undefined,
      name: "Status",
      selector: (row, i) => row.RequestFormTypeID,
      cell: (row, i) => (
        <div className="row col-lg-12 m-2 resp-space">
          <div className="form-check col-lg-6 ">
            <input
              type="radio"
              className="form-check-input"
              name={`Type_RequestMGUserFormPermission.${i}.ActiveStatus`}
              value={1}
              id={`active-status-mg-${i}`}
              checked={
                facilityInformationData["Type_RequestMGUserFormPermission"]?.[
                i
                ]?.["ActiveStatus"] === 1
              }
              onChange={(e) => handleManagementFormTableChanges(e, row)}
            />
            <label className="form-check-label fs-5" htmlFor={`active-status-mg-${i}`}>Active</label>
          </div>

          <div className="form-check col-lg-6">
            <input
              type="radio"
              className="form-check-input"
              name={`Type_RequestMGUserFormPermission.${i}.ActiveStatus`}
              value={0}
              id={`inactive-status-mg-${i}`}
              checked={
                facilityInformationData["Type_RequestMGUserFormPermission"]?.[
                i
                ]?.["ActiveStatus"] === 0
              }
              onChange={(e) => handleManagementFormTableChanges(e, row)}
            />
            <label className="form-check-label fs-5" htmlFor={`inactive-status-mg-${i}`}>Inactive</label>
          </div>
        </div>
      ),
      sortable: false,
    },
  ];

  const getInmateRequestForm = () => {
    try {
      dispatch(facilityAction?.getInmateRequestForm());
    } catch (error) {
      showToastNotification("Failed to get Inmate request form", "warning");
    }
  };

  const getManagementRequestForm = () => {
    try {
      dispatch(facilityAction?.getManagementRequestForm());
    } catch (error) {
      showToastNotification("Failed to get Management request form", "warning");
    }
  };

  const handleInmateFormTableChanges = (e, row, input) => {
    const facilityData = { ...facilityInformationData };
    const facilityPerission = facilityData["Type_RequestFormPermission"];
    const updateInmatePermission = facilityPerission?.map(
      (permission, index) => {
        if (permission?.RequestFormTypeID === row?.RequestFormTypeID) {
          if (input === "FrequencyCount") {
            return {
              ...permission, [input]: e?.value !== null && e !== null ? e?.value : -1,
              FrequencyCalenderType: e?.value !== -1
                && permission?.FrequencyCalenderType === -1 ? 1 : e?.value === -1 || e === null ? -1 : permission?.FrequencyCalenderType
            };
          }
          else if (input === "FrequencyCalenderType") {
            return {
              ...permission, [input]: e?.value || -1,
              FrequencyCount: e?.value === -1 || e === null ? -1 : permission?.FrequencyCount
            };
          }
          else {
            const { name, value } = e?.target;
            const match = name.match(
              /Type_RequestFormPermission\.(\d+)\.(\w+)/
            );
            if (match[2] === "FacilityRequestFormTitle") {
              setErrorMessage({
                ...errorMessage,
                [`Type_RequestFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`]: value?.trim()?.length == 0 ? "Form title is required." : "",
              });
            }

            return {
              ...permission,
              [match[2]]:
                match[2] === "FacilityRequestFormTitle"
                  ? value
                  : parseInt(value),
            };
          }
        }
        return permission;
      }
    );
    facilityData["Type_RequestFormPermission"] = updateInmatePermission;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleInmateFormTableOnblur = (e, row, input) => {
    const facilityData = { ...facilityInformationData };
    const facilityPerission = facilityData["Type_RequestFormPermission"];
    const updateInmatePermission = facilityPerission?.map(
      (permission, index) => {
        if (permission?.RequestFormTypeID === row?.RequestFormTypeID) {
          if (input === "FrequencyCount") {
            return {
              ...permission, [input]: e?.value !== null && e !== null ? e?.value : -1,
              FrequencyCalenderType: e?.value !== -1
                && permission?.FrequencyCalenderType === -1 ? 1 : e?.value === -1 || e === null ? -1 : permission?.FrequencyCalenderType
            };
          }
          else if (input === "FrequencyCalenderType") {
            return {
              ...permission, [input]: e?.value || -1,
              FrequencyCount: e?.value === -1 || e === null ? -1 : permission?.FrequencyCount
            };
          }
          else {
            const { name, value } = e?.target;
            const match = name.match(
              /Type_RequestFormPermission\.(\d+)\.(\w+)/
            );
            if (match[2] === "FacilityRequestFormTitle") {
              setErrorMessage({
                ...errorMessage,
                [`Type_RequestFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`]: value?.trim()?.length == 0 ? "Form title is required." : "",
              });
            }

            return {
              ...permission,
              [match[2]]:
                match[2] === "FacilityRequestFormTitle"
                  ? value ? value.trim() : ""
                  : parseInt(value),
            };
          }
        }
        return permission;
      }
    );
    facilityData["Type_RequestFormPermission"] = updateInmatePermission;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleManagementFormTableChanges = (e, row) => {
    const facilityData = { ...facilityInformationData };
    const facilityPerission = facilityData["Type_RequestMGUserFormPermission"];
    const updateInmatePermission = facilityPerission?.map(
      (permission, index) => {
        if (permission?.RequestFormTypeID === row?.RequestFormTypeID) {
          const { name, value } = e?.target;

          const match = name.match(
            /Type_RequestMGUserFormPermission\.(\d+)\.(\w+)/
          );
          if (match[2] === "FacilityRequestFormTitle") {
            setErrorMessage({
              ...errorMessage,
              [`Type_RequestMGUserFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`]: value?.trim()?.length == 0 ? "Form title is required." : "",
            });
          }

          return {
            ...permission,
            [match[2]]: match[2] === `ActiveStatus` ? parseInt(value) : value,
          };
        }
        return permission;
      }
    );
    facilityData["Type_RequestMGUserFormPermission"] = updateInmatePermission;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleManagementFormTableOnblur = (e, row) => {
    const facilityData = { ...facilityInformationData };
    const facilityPerission = facilityData["Type_RequestMGUserFormPermission"];
    const updateInmatePermission = facilityPerission?.map(
      (permission, index) => {
        if (permission?.RequestFormTypeID === row?.RequestFormTypeID) {
          const { name, value } = e?.target;

          const match = name.match(
            /Type_RequestMGUserFormPermission\.(\d+)\.(\w+)/
          );
          if (match[2] === "FacilityRequestFormTitle") {
            setErrorMessage({
              ...errorMessage,
              [`Type_RequestMGUserFormPermission.${row.RequestFormTypeID}.FacilityRequestFormTitle`]: value?.trim()?.length == 0 ? "Form title is required." : "",
            });
          }

          return {
            ...permission,
            [match[2]]: match[2] === `ActiveStatus` ? parseInt(value) : value ? value.trim() : "",
          };
        }
        return permission;
      }
    );
    facilityData["Type_RequestMGUserFormPermission"] = updateInmatePermission;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const addInmateForm = (e, index) => {
    const { name, checked } = e?.target;
    let updatedFormsDetails = { ...FormsDetails };
    if (name === "inmateSelectAll") {
      const updatedForm = FormsDetails?.inmateRequestForm?.map((form) => {
        if (
          // form?.RequestFormType === "Visitor Request Form" ||
          // form?.RequestFormType === "Public Defender Services" ||
          // form?.RequestFormType === "Public Defender Services - Crisp"
          form?.RequestFormTypeID === 1 ||
          form?.RequestFormTypeID === 59 ||
          form?.RequestFormTypeID === 62 || form?.RequestFormTypeID === 63
        ) {
          return { ...form, isActive: (FormsDetails?.checkInmateRequestForm.some((items) => items.RequestFormTypeID === form.RequestFormTypeID && items.isActive === true)) ? true : checked, isShowSelectBox: false };
        }
        return { ...form, isActive: (FormsDetails?.checkInmateRequestForm.some((items) => items.RequestFormTypeID === form.RequestFormTypeID && items.isActive === true)) ? true : checked, isShowSelectBox: true };
      });
      updatedFormsDetails.isInmateSelectAll = checked;
      updatedFormsDetails.inmateRequestForm = updatedForm;
      //setIsInmateSelectAll(checked);
      //setInmateRequestForm(updatedForm);
    } else {
      const updateActiveStatus = FormsDetails?.inmateRequestForm.map((obj, i) => {
        if (i === index) {
          if (
            // obj?.RequestFormType === "Visitor Request Form" ||
            // obj?.RequestFormType === "Public Defender Services" ||
            // obj?.RequestFormType === "Public Defender Services - Crisp"
            obj?.RequestFormTypeID === 1 ||
            obj?.RequestFormTypeID === 59 ||
            obj?.RequestFormTypeID === 62 || obj?.RequestFormTypeID === 63
          ) {
            return { ...obj, isActive: checked, isShowSelectBox: false };
          }
          return { ...obj, isActive: checked, isShowSelectBox: true };
        } else {
          return obj;
        }
      });
      updatedFormsDetails.inmateRequestForm = updateActiveStatus;
      //setInmateRequestForm(updateActiveStatus);
      const isAllActive = updateActiveStatus?.every((obj) => obj?.isActive);
      //setIsInmateSelectAll(isAllActive);
      updatedFormsDetails.isInmateSelectAll = isAllActive;

    }
    dispatch(facilityAction.setFormsDetails(updatedFormsDetails));
  };

  const addManagementForm = (e, index) => {
    const { name, checked } = e?.target;
    let updatedFormsDetails = { ...FormsDetails };
    if (name === "managementSelectAll") {
      const updatedForm = FormsDetails?.managementRequestForm?.map((form) => {
        if (
          // form?.RequestFormType === "Visitor Request Form" ||
          // form?.RequestFormType === "Public Defender Services" ||
          // form?.RequestFormType === "Public Defender Services - Crisp"
          form?.RequestFormTypeID === 1 ||
          form?.RequestFormTypeID === 59 ||
          form?.RequestFormTypeID === 62 || form?.RequestFormTypeID === 63
        ) {
          return { ...form, isActive: (FormsDetails?.checkManagementRequestForm.some((items) => items.RequestFormTypeID === form.RequestFormTypeID && items.isActive === true)) ? true : checked, isShowSelectBox: false };
        }
        return { ...form, isActive: (FormsDetails?.checkManagementRequestForm.some((items) => items.RequestFormTypeID === form.RequestFormTypeID && items.isActive === true)) ? true : checked, isShowSelectBox: true };
      });
      updatedFormsDetails.isManagementSelectAll = checked;
      updatedFormsDetails.managementRequestForm = updatedForm;
      //setIsManagementSelectAll(checked);
      //setManagementRequestForm(updatedForm);
    } else {
      const updateActiveStatus = FormsDetails?.managementRequestForm.map((obj, i) =>
        i === index ? { ...obj, isActive: checked } : obj
      );
      updatedFormsDetails.managementRequestForm = updateActiveStatus;
      //setManagementRequestForm(updateActiveStatus);
      const isAllActive = updateActiveStatus?.every((obj) => obj?.isActive);
      updatedFormsDetails.isManagementSelectAll = isAllActive;
      //setIsManagementSelectAll(isAllActive);
    }
    dispatch(facilityAction.setFormsDetails(updatedFormsDetails));
  };

  const addForm = (e) => {
    e?.preventDefault();
    const isAnyoneSelectInInmateForm = FormsDetails?.inmateRequestForm?.some(
      (obj) => obj?.isActive
    );
    const isAnyoneSelectManagementForm = FormsDetails?.managementRequestForm?.some(
      (obj) => obj?.isActive
    );

    if (!isAnyoneSelectInInmateForm && !isAnyoneSelectManagementForm) {
      showToastNotification("Please Select Form's", "warning");
      return;
    }

    const defenderService = FormsDetails?.inmateRequestForm.find(
      (obj) => obj.RequestFormType === "Public Defender Services"
    );
    const defenderServiceCrisp = FormsDetails?.inmateRequestForm.find(
      (obj) => obj.RequestFormType === "Public Defender Services - Crisp"
    );

    if (!isAnyoneSelectInInmateForm && isAnyoneSelectManagementForm) {
      showToastNotification(
        "Please Choose Forms From Inmate Form's",
        "warning"
      );
      return;
    }
    if (isAnyoneSelectInInmateForm && !isAnyoneSelectManagementForm) {
      showToastNotification(
        "Please Choose Forms From Management Form's",
        "warning"
      );
      return;
    }

    const facilityData = { ...facilityInformationData };
    if (facilityData["Type_RequestFormPermission"]?.length > 0 && facilityData?.IsFormReqAccess === 1) {
      const isPDSCrispActive = facilityData["Type_RequestFormPermission"].some((item) => item.RequestFormType === "Public Defender Services - Crisp" && item.ActiveStatus === 1);
      const isPDSActive = facilityData["Type_RequestFormPermission"].some((item) => item.RequestFormType === "Public Defender Services" && item.ActiveStatus === 1);

      const isPDSCrisp = facilityData["Type_RequestFormPermission"].some((item) => item.RequestFormType === "Public Defender Services - Crisp");
      const isPDS = facilityData["Type_RequestFormPermission"].some((item) => item.RequestFormType === "Public Defender Services");
      if (isPDSCrispActive && isPDSActive) {
        Popup({
          title: "Message",
          text: `Cannot activate both PDS forms at the same time.`,
          icon: "info",
          confirmButtonText: "Ok",
        });
        return;
      }
      else if (!(isPDSCrisp && isPDS)) {
        if (defenderService?.isActive && defenderServiceCrisp?.isActive) {
          showToastNotification(
            "One of the PDS form is already added. So, unable to add the another PDS form",
            "warning"
          );
          return;
        }
      }
    }
    else {
      if (defenderService?.isActive && defenderServiceCrisp?.isActive) {
        showToastNotification(
          "One of the PDS form is already added. So, unable to add the another PDS form",
          "warning"
        );
        return;
      }
    }
    if (isAnyoneSelectInInmateForm && isAnyoneSelectManagementForm) {
      Popup({
        title: "Message",
        text: `Are you sure you want to proceed with the selected forms?`,
        icon: "info",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        onConfirm: () => showFormTable(true),
      });
      return;
    }
  };

  const showFormTable = () => {
    // setShowSelectedFormTable(true);
    const inmateFilteredList = FormsDetails?.inmateRequestForm?.filter(
      (form) => form?.isActive
    );
    const managementFilteredList = FormsDetails?.managementRequestForm?.filter(
      (form) => form?.isActive
    );

    // setInmateFormTable(inmateFilteredList);
    // setManagementFormTable(managementFilteredList);

    let facilityData = { ...facilityInformationData };
    let updateInmateFormData = [
      ...facilityInformationData["Type_RequestFormPermission"],
    ];
    let updateManagementFormData = [
      ...facilityInformationData["Type_RequestMGUserFormPermission"],
    ];

    updateInmateFormData = inmateFilteredList?.map((form, index) => {
      return {
        RFPermissionID: 0,
        FacilityID: 0,
        RequestFormTypeID: form?.RequestFormTypeID,
        RequestFormType: form?.RequestFormType,
        ActiveStatus: 1,
        FrequencyCount: -1,
        FrequencyCalenderType: -1,
        FacilityRequestFormTitle: "",
        isShowSelectBox: (form?.RequestFormTypeID === 1 ||
          form?.RequestFormTypeID === 59 || form?.RequestFormTypeID === 63 ||
          form?.RequestFormTypeID === 62) ? false : true,
      };
    });
    updateManagementFormData = managementFilteredList?.map((form, index) => {
      return {
        RMGUserPermissionID: 0,
        FacilityID: 0,
        RequestFormTypeID: form?.RequestFormTypeID,
        RequestFormType: form?.RequestFormType,
        ActiveStatus: 1,
        FacilityRequestFormTitle: "",
        isShowSelectBox: form?.isShowSelectBox,
      };
    });

    let Type_RequestFormPermission = [];

    Type_RequestFormPermission = updateInmateFormData.filter((data) => {
      const exists = facilityData["Type_RequestFormPermission"].some(item => item.RequestFormTypeID === data.RequestFormTypeID);
      return !exists;
    });

    let Type_RequestMGUserFormPermission = [];

    Type_RequestMGUserFormPermission = updateManagementFormData.filter((data) => {
      const exists = facilityData["Type_RequestMGUserFormPermission"].some(item => item.RequestFormTypeID === data.RequestFormTypeID);
      return !exists;
    });

    facilityData["Type_RequestMGUserFormPermission"] = [
      ...facilityData["Type_RequestMGUserFormPermission"],
      ...Type_RequestMGUserFormPermission
    ];

    facilityData["Type_RequestFormPermission"] = [
      ...facilityData["Type_RequestFormPermission"],
      ...Type_RequestFormPermission
    ];

    const checkInmateRequestForm = InmateForm?.map((items) => {
      return {
        ...items,
        isActive: updateInmateFormData.some((data) => data.RequestFormTypeID === items.RequestFormTypeID)
      }
    });
    const checkManagementRequestForm = ManagementForm?.map((items) => {
      return {
        ...items,
        isActive: updateManagementFormData.some((data) => data.RequestFormTypeID === items.RequestFormTypeID)
      }
    })
    dispatch(facilityAction.setFacilityData(facilityData));
    dispatch(facilityAction.setFormsDetails({
      ...FormsDetails,
      checkInmateRequestForm: checkInmateRequestForm,
      checkManagementRequestForm: checkManagementRequestForm
    }));
  };

  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title="To enable the forms which shall be used by inmates as required"
      >
        <i className="fas fa-file-invoice me-2"></i>FORMS
      </h4>
      <div className="mb-2 font-size-13">
        NOTE :- Request Form 27 - After submission to the administration, the
        inmate's form becomes invisible until the administration replies, after
        which it becomes visible again but is hidden once viewed.
      </div>
      <h5>Select required forms and rename the form below</h5>
      {errorMessage && Object?.keys(errorMessage).length > 0 && (
        <div className="text-danger fw-700 fs-6 mt-1">
          {(errorMessage &&
            errorMessage["Type_RequestFormPermission"] &&
            errorMessage["Type_RequestFormPermission"]) ||
            (errorMessage["Type_RequestMGUserFormPermission"] &&
              errorMessage["Type_RequestMGUserFormPermission"])}
        </div>
      )}

      <div className="row mt-2">
        <div className="col-12 col-md-6 mb-3 mb-md-0" style={{ height: "300px" }}>
          <div
            className="shadow-sm border-all rounded overflow-auto h-100"
          >
            <h4 className="position-sticky top-0 bg-white p-2 z-1">Inmate</h4>
            <div className="p-2">
              <CheckBoxInput
                label="Select / Unselect All"
                name="inmateSelectAll"
                id="inmateSelectAll"
                style={
                  facilityInformationData?.IsFormReqAccess &&
                    !FormsDetails?.isInmateSelectAll
                    ? {
                      borderColor: "#94989ccc",
                    }
                    : {}
                }
                disabled={!facilityInformationData?.IsFormReqAccess}
                handleClick={addInmateForm}
                checked={FormsDetails?.isInmateSelectAll}
              />
              {InmateForm?.map((form, i) => {
                return (
                  <div key={i}>
                    <CheckBoxInput
                      label={form?.RequestFormType}
                      name={form?.RequestFormType}
                      id={form?.RequestFormType}
                      style={
                        !(
                          FormsDetails?.checkInmateRequestForm[i]?.["isActive"] ||
                          !facilityInformationData?.IsFormReqAccess
                        ) &&
                          !(
                            FormsDetails?.inmateRequestForm[i]?.["isActive"] ||
                            FormsDetails?.isInmateSelectAll
                          )
                          ? {
                            borderColor: "#94989ccc",
                          }
                          : {}
                      }
                      value={form?.RequestFormTypeID}
                      disabled={
                        FormsDetails?.checkInmateRequestForm[i]?.["isActive"] ||
                        !facilityInformationData?.IsFormReqAccess
                      }
                      handleClick={
                        !FormsDetails?.checkInmateRequestForm[i]?.["isActive"] ||
                          !facilityInformationData?.IsFormReqAccess
                          ? (e) => addInmateForm(e, i)
                          : undefined
                      }
                      checked={
                        FormsDetails?.inmateRequestForm[i]?.["isActive"] ||
                        FormsDetails?.isInmateSelectAll
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6" style={{ height: "300px" }}>
          <div
            className="shadow-sm border-all rounded overflow-auto h-100"
          >
            <h4 className="position-sticky top-0 bg-white p-2 z-1">Management</h4>
            <div className="p-2">
              <CheckBoxInput
                label="Select / Unselect All"
                name="managementSelectAll"
                id="managementSelectAll"
                style={
                  facilityInformationData?.IsFormReqAccess &&
                    !FormsDetails?.isManagementSelectAll
                    ? {
                      borderColor: "#94989ccc",
                    }
                    : {}
                }
                disabled={!facilityInformationData?.IsFormReqAccess}
                handleClick={addManagementForm}
                checked={FormsDetails?.isManagementSelectAll}
              />
              {ManagementForm?.map((form, i) => {
                return (
                  <div key={i}>
                    <CheckBoxInput
                      label={form?.RequestFormType}
                      name={form?.RequestFormType}
                      id={form?.RequestFormType}
                      value={form?.RequestFormTypeID}
                      style={
                        !(
                          FormsDetails?.checkManagementRequestForm[i]?.[
                          "isActive"
                          ] || !facilityInformationData?.IsFormReqAccess
                        ) &&
                          !(
                            FormsDetails?.managementRequestForm[i]?.["isActive"] ||
                            FormsDetails?.isManagementSelectAll
                          )
                          ? {
                            borderColor: "#94989ccc",
                          }
                          : {}
                      }
                      disabled={
                        FormsDetails?.checkManagementRequestForm[i]?.["isActive"] ||
                        !facilityInformationData?.IsFormReqAccess
                      }
                      handleClick={
                        !FormsDetails?.checkManagementRequestForm[i]?.["isActive"] ||
                          !facilityInformationData?.IsFormReqAccess
                          ? (e) => addManagementForm(e, i)
                          : undefined
                      }
                      checked={
                        FormsDetails?.managementRequestForm[i]?.["isActive"] ||
                        FormsDetails?.isManagementSelectAll
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {facilityInformationData?.IsFormReqAccess === 1 && (
        <div className="mt-3 d-flex flex-wrap justify-content-center">
          <Button
            type="button"
            label="Add Forms"
            status="btn-label"
            //icon={"fa-solid fa-plus"}
            imgsrc={AddIcon}
            disabled={!facilityInformationData?.IsFormReqAccess}
            onClick={addForm}
          />
        </div>
      )}

      <>
        {facilityInformationData?.Type_RequestFormPermission?.length > 0 && (
          <div className="overflow-x-auto mt-5 border border-dark-grey">
            <div className="col-md-8 mb-2 m-2">
              <h2 className="form_title_uppercase text-color">Inmate</h2>
            </div>
            <Table
              columns={inmateTableColumn}
              data={facilityInformationData?.Type_RequestFormPermission}
              fixedHeaderScrollHeight="400px"
              fixedHeader={true}
            />
          </div>
        )}
        {facilityInformationData?.Type_RequestMGUserFormPermission?.length > 0 && (
          <div className="overflow-x-auto mt-5 border border-dark-grey">
            <div className="col-md-8 mb-2 m-2">
              <h2 className="form_title_uppercase text-color">Management</h2>
            </div>
            <Table
              columns={managementTableColumn}
              data={facilityInformationData?.Type_RequestMGUserFormPermission}
              fixedHeaderScrollHeight="300px"
              fixedHeader={true}
            />
          </div>
        )}
      </>
    </div>
  );
}

export default React.memo(FacilityForms);
